import * as React from 'react';
import { MainWrapper, requestsTableStyles } from './style';
import OnboardingInro from './components/OnboardingInro';
import OnboardingHomeBg from './components/OnboardingHomeBg';
import RequestsFilter from './components/RequestsFilter';
import RequestsPagination from './components/RequestsPagination';
import RequestsTable from './components/RequestsTable';
import { useRequestsFilters } from './hooks/useRequestsFilters';
import { useEffect, useRef } from 'react';
import { 
  callToGetRequestsPaginated, 
  setFilters, 
  setCurrentPage
} from './ducks/slice';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from 'api-store/store';
import { 
  getRequests, 
  getCurrentPage, 
  getTotalPages, 
  getIsLoadingRequests,
  getFilters,
  getSortBy,
  getSortOrder,
  getTotalCount
} from './ducks/selectors';

export default function Requests() {
  const userData = useSelector((state: RootState) => state.userData);
  const dispatch = useDispatch();
  const isMounted = useRef(false);
  const requestList = useSelector(getRequests);
  const currentPage = useSelector(getCurrentPage);
  const totalPages = useSelector(getTotalPages);
  const isLoading = useSelector(getIsLoadingRequests);
  const filters = useSelector(getFilters);
  const sortBy = useSelector(getSortBy);
  const sortOrder = useSelector(getSortOrder);
  const totalCount = useSelector(getTotalCount);
  
  // Use custom hook for filter management
  const {
    localFilters,
    getPersistedFilters,
    handleFilterChange,
    handleApplyFilters,
    handleClearFilters,
  } = useRequestsFilters();

  useEffect(() => {
    if(!isMounted.current) {
      // Load persisted filters into Redux state
      const persistedFilters = getPersistedFilters();
      if (persistedFilters.status || persistedFilters.onboardingType || persistedFilters.requestNumber || persistedFilters.raisedBy || persistedFilters.raisedFor) {
        dispatch(setFilters(persistedFilters));
        isMounted.current = true;
        return;
      }
      isMounted.current = true;
    }
    dispatch(callToGetRequestsPaginated({ email: userData.user_name.replace("tmnatest", "toyota") }));
  }, [currentPage, filters, sortBy, sortOrder, dispatch, userData.user_name, getPersistedFilters]);

  const handlePageChange = (event: React.ChangeEvent<unknown>, page: number) => {
    dispatch(setCurrentPage(page));
  };

  return (
      <MainWrapper>
        <OnboardingHomeBg />
        <OnboardingInro title="Track Requests" description={"Track your all self service requests here."} />
      
      <div style={requestsTableStyles}>
        {/* Filter Section */}
        <RequestsFilter
          localFilters={localFilters}
          totalCount={totalCount}
          onFilterChange={handleFilterChange}
          onApplyFilters={handleApplyFilters}
          onClearFilters={handleClearFilters}
        />

        {/* Table Section */}
        <RequestsTable
          requestList={requestList || []}
          isLoading={isLoading}
          currentPage={currentPage}
          sortBy={sortBy}
          sortOrder={sortOrder}
        />

        {/* Pagination Section */}
        <RequestsPagination
          totalPages={totalPages}
          currentPage={currentPage}
          isLoading={isLoading}
          onPageChange={handlePageChange}
        />
      </div>
      </MainWrapper>
  );
}
